// ItemList.tsx
import React from 'react';
import arrowIconRightLarge from "./../../../../assets/_ArrowIconRightLarg_.svg";
import { useNavigate } from 'react-router-dom';
import styles from "./styles.module.scss";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

interface ItemProps {
  icon: React.ReactNode;
  name: string;
  path: string;
}

const Item: React.FC<ItemProps> = ({ icon, name, path }) => {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      className={styles.itemContainer}
      onClick={() => navigate(path)}
    >
      <Box className={styles.iconBox}>{icon}</Box>
      <div className={styles.name}>{name}</div>
      <img src={arrowIconRightLarge} className={styles.arrowIcon}/>
    </Stack>
  );
};

interface ItemListProps {
  items: ItemProps[];
}

export const ItemList: React.FC<ItemListProps> = ({ items }) => {
  return (
    <Stack spacing={1.5}>
      {items.map((item, index) => (
        <Item key={index} icon={item.icon} name={item.name} path={item.path} />
      ))}
    </Stack>
  );
};
